export type Adapter<
  A,
  B,
  keysT extends keyof toAdaptersT,
  toAdaptersT extends {
    [key in keysT]: (...args: any[]) => unknown
  }
> = {
  from: (b: B, ...args: any[]) => A
} & toAdaptersT

export const makeAdapter = <
  A,
  B,
  keysT extends keyof toAdaptersT,
  toAdaptersT extends {
    [key in keysT]: (...args: any[]) => unknown
  }
>(
  adapters: Adapter<A, B, keysT, toAdaptersT>
) => adapters
